<template>
  <el-date-picker
    v-model="formData"
    :picker-options="{ disabledDate: disabledDate }"
    prefix-icon="fa fa-calendar"
    format="d 'de' MMMM 'de' yyyy"
  />
</template>

<script>
import { DatePicker } from "element-ui";

export default {
  name: "DateAvaliationItemStrategy",
  components: {
    [DatePicker.name]: DatePicker,
  },
  props: {
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({
        min_date: null,
        max_date: null,
      }),
    },
    value: {
      type: Object,
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
    min_date() {
      if (!this.config.min_date) return null;

      return new Date(this.config.min_date);
    },
    max_date() {
      if (!this.config.max_date) return null;

      return new Date(this.config.max_date);
    },
    disabledDate() {
      return (date) => {
        if (this.min_date && date < this.min_date) {
          return true;
        }
        if (this.max_date && date > this.max_date) {
          return true;
        }
        return false;
      };
    },
  },
}
</script>
